import { BaseType } from 'src/types/base.type';
import { FlatItem } from 'src/types/elements.type';
import { IJobCategory } from '../master_data/jobCategory.type';

export interface ITicketCategory extends BaseType {
  id: number;
  ticketCategoryCode: string;
  ticketTypeId?: number;
  departmentId?: number;
  manpowerSupplyTypeId?: number;
  useForm?: UseFormIdEn;
  formId?: number;
  name: string;
  nameEn: string;
  isHighLevel: boolean;
  isGlobalRaise: boolean;
  effectiveFromDate?: Date;
  effectiveToDate?: Date;
  description: string;
  isRemovable: boolean;
  isActive: boolean;
  ticketType: FlatItem;
  department: FlatItem;
  manpowerSupplyType: FlatItem;
  updatedByObj?: FlatItem;
  createdByObj?: FlatItem;
  ticketCategoryJDEffects?: ITicketCategoryJDEffect[];
  ticketCategoryTasks?: ITicketCategoryTask[];

  ticketCategoryMappings: ITicketCategoryMapping[];
  ticketCategoryTicketGroups: ITicketCategoryTicketGroup[];
}

interface ITicketCategoryMapping extends BaseType {
  hrTicketCategory: FlatItem;
  hrTicketCategoryId: number;
  ticketCategoryId: number;
}

interface ITicketCategoryTicketGroup extends BaseType {
  id: number;
  ticketCategoryId: number;
  ticketCategoryGroupId: number;
}

export type TicketCategoryAdd = Partial<
  Omit<
    ITicketCategory,
    | 'id'
    | 'createdDate'
    | 'lastModifiedDate'
    | 'ticketType'
    | 'department'
    | 'ticketCategoryProcesses'
    | 'manpowerSupplyType'
    | 'isRemovable'
    | 'ticketCategoryJDEffects'
    | 'ticketCategoryTasks'
    | 'ticketCategoryMappings'
    | 'ticketCategoryTicketGroups'
  > & {
    ticketCategoryJDEffects?: TicketCategoryJDEffectAdd[];
    ticketCategoryTasks?: TicketCategoryTaskAdd[];
    ticketCategoryMappingIds?: number[];
    ticketCategoryMappings?: Partial<ITicketCategoryMapping>[];
    ticketCategoryTicketGroupIds?: number[];
    ticketCategoryTicketGroups?: Partial<ITicketCategoryTicketGroup>[];
  }
>;

export interface categoryFlatItem extends FlatItem {
  isUsed: boolean;
}
export interface ITicketCategoryShort extends FlatItem {
  useForm?: UseFormIdEn;
  formId?: number;
  manpowerSupplyTypeId?: number;
}

export enum UseFormIdEn {
  emailForm = 1,
  accessForm = 2,
  manpowerSupplyForm = 3
}

export enum UseFormCodeEn {
  emailForm = 'emailForm',
  accessForm = 'accessForm',
  manpowerSupplyForm = 'manpowerSupplier'
}

export interface TicketCategoryToRaise {
  id: number | string;
  code: string;
  name: string;
  description: string;
  useForm?: UseFormIdEn;
  manpowerSupplyTypeId: number;
  formId?: number;
  ticketCategoryGroupId: number;
  ticketCategoryGroup: FlatItem;
}

// ticketCategoryJDEffects
export interface ITicketCategoryJDEffect extends BaseType {
  ticketCategoryId: number;
  jobCategoryId: number;
  jobCategory: IJobCategory;
  ticketCategoryJobTaskEffects: IJobTask[];
}

export type TicketCategoryJDEffectAdd = Partial<
  Omit<ITicketCategoryJDEffect, 'createdDate' | 'lastModifiedDate' | 'ticketCategoryJobTaskEffects'> & {
    ticketCategoryJobTaskEffects: JobTaskAdd[];
  }
>;

export interface IJobTask extends BaseType {
  id: string;
  ticketCategoryJDEffectId: number;
  jobTaskId: number;
  isActive: boolean;
  jobTask: FlatItem;
  ticketCategoryTaskActivityEffects: ITaskActivity[];
}

export type JobTaskAdd = Partial<
  Omit<IJobTask, 'ticketCategoryTaskActivityEffects'> & {
    ticketCategoryTaskActivityEffects: TaskActivityAdd[];
  }
>;

// ticketCategoryTasks

export interface ITicketCategoryTask extends BaseType {
  ticketCategoryId: number;
  jobTaskId: number;
  jobTask: FlatItem;
  ticketCategoryTaskActivities: ITaskActivity[];
  jobCategory: FlatItem;
}

export type TicketCategoryTaskAdd = Partial<
  Omit<ITicketCategoryTask, 'createdDate' | 'lastModifiedDate' | 'ticketCategoryTaskActivities'> & {
    ticketCategoryTaskActivities: TaskActivityAdd[];
  }
>;

// taskActivity
export interface ITaskActivity extends BaseType {
  id: string;
  ticketCategoryTaskId: number;
  taskActivityId: number;
  isActive: boolean;
  taskActivity: FlatItem;
}

export type TaskActivityAdd = Partial<ITaskActivity>;
